'use client'

import { useState, SubmitEvent, SubmitEventHandler } from 'react'
import Link from 'next/link'
import Label from '@/components/common/Label'
import { className as classNameDefault } from '@/components/common/styles'
import Panel from '@/components/common/Panel'

const User = ({ className }: { className?: string }) => {
  const [userName, setUserName] = useState('jl75')
  const [role, setRole] = useState('owner')
  const [group, setGroup] = useState('REGIO WEST')
  const [site, setSite] = useState('Filiaal Amsterdam Van Woustraat')
  const [email, setEmail] = useState('info@smartbits-consulting.nl')
  const [phoneNumber, setPhoneNumber] = useState('+3120678100')
  const [fullName, setFullName] = useState('Jan Lubbers')

  const handleUserSettings: SubmitEventHandler = (
    e: SubmitEvent<HTMLInputElement>,
  ) => {
    e.preventDefault()
    console.log({
      userName,
      role,
      group,
      site,
      fullName,
      email,
      phoneNumber,
    })
  }

  return (
    <div className={`p-4 ${className}`}>
      <Panel title="User (you)">
        <form onSubmit={handleUserSettings}>
          <div className="grid grid-cols-2 gap-x-8 bg-gray-50 dark:bg-gray-900 text-black dark:text-white">
            <div className="col-span-2 md:col-span-1">
              <Label
                id="user-name"
                label="User name"
                tooltip="User name cannot contain spaces."
                icon="info-circle"
                iconcolor="text-primary"
                ttid="tt-user-name"
                value={userName}
                onChange={({ target }) =>
                  setUserName((target as HTMLInputElement).value)
                }
              />
            </div>
            <div className="col-span-2 md:col-span-1">
              <Label
                id="role"
                label="Role"
                value={role}
                disabled={true}
                onChange={({ target }) =>
                  setRole((target as HTMLInputElement).value)
                }
              />
            </div>
            <div className="col-span-2">
              <Label
                id="group"
                label="Group"
                value={group}
                disabled={true}
                onChange={({ target }) =>
                  setGroup((target as HTMLInputElement).value)
                }
              />
            </div>
            <div className="col-span-2">
              <Label
                id="site"
                label="Site"
                value={site}
                disabled={true}
                onChange={({ target }) =>
                  setSite((target as HTMLInputElement).value)
                }
              />
            </div>
            <div className="col-span-2">
              <Label
                id="full-name"
                label="Full name"
                value={fullName}
                onChange={({ target }) =>
                  setFullName((target as HTMLInputElement).value)
                }
              />
            </div>
            <div className="col-span-2 md:col-span-1">
              <Label
                id="email"
                label="Email"
                tooltip="Email was last verified on 2019-11-16."
                icon="check-circle"
                iconcolor="text-success"
                ttid="tt-email"
                value={email}
                onChange={({ target }) =>
                  setEmail((target as HTMLInputElement).value)
                }
              />
            </div>
            <div className="col-span-2 md:col-span-1">
              <Label
                id="phone-number"
                label="Phone number"
                value={phoneNumber}
                onChange={({ target }) =>
                  setPhoneNumber((target as HTMLInputElement).value)
                }
              />
            </div>
            <div className="col-span-2 pb-4">
              <Link href="#!">
                <div className="text-blue-600 dark:text-blue-400 hover:underline decoration-2">
                  Read more about why and how we verify a user
                </div>
              </Link>
            </div>
            <div className="col-span-2 pb-2">
              <button className={`${classNameDefault} float-end`} type="submit">
                Update user
              </button>
            </div>
          </div>
        </form>
      </Panel>
    </div>
  )
}

export default User
